import React from 'react';

import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Grid, GridColumn as Column } from '@progress/kendo-react-grid';
import { withStyles } from '@material-ui/core/styles';

import classes from '../CreateEntityModal.module.css';

const CustomSwitch = withStyles({
    switchBase: {
        color:       '#fafafa',
        '&$checked': {
            color: '#212121',
        },
        '&$checked + $track': {
            backgroundColor: '#212121',
        },
    },
    checked: {},
    track:   {},
})(Switch);

const ApplicationsTab = ({
    setUserApplications,
    userApplications
}) => {

    const onChange = (dataItem) => {
        const { enabled, id } = dataItem;
        let applications = [ ...userApplications ];

        let item = applications.find(item => item.id === id);
        item.enabled = !enabled;

        const index = applications.findIndex(item => item.id === id);
        applications[index] = item;

        setUserApplications(applications);
    };

    const accessCell = props => {
        const { dataItem } = props;

        return (
            <td>
                <FormControlLabel
                    control={
                        <CustomSwitch
                            size="small"
                            checked={dataItem.enabled}
                            name={dataItem.applicationName}
                            onChange={() => onChange(dataItem)}
                        />
                    }
                    label={ dataItem.enabled ? 'Yes' : 'No'}
                />
            </td>
        );
    };

    return (
        <div className={classes.userformColumn}>
            <div className={classes.userDetails}>
                <div className={classes.technicianColumn}>
                    <Grid
                        style={{
                            fontSize: '1rem'
                        }}
                        data={userApplications}
                    >
                        <Column field="applicationName" title="Application" width="300" />
                        <Column
                            field=""
                            title=""
                            width="auto"
                            cell={accessCell}
                        />
                    </Grid>
                </div>
            </div>
        </div>
    );
};

export default ApplicationsTab;
